(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8193],{

/***/ 7872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/airdrop",
      function () {
        return __webpack_require__(24129);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export menus */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27234);



var menus = [];
if (true) {
    menus.push({
        label: "IDO",
        route: "/ido/vesting"
    });
}
if (false) {}
menus.push({
    label: "Mining",
    route: "/network/mining"
});
var hasAnnouncement = !!"Migrate your staking v1 token to karat.club";
var NetworkMenu = function() {
    var hideAnnouncement = (0,_stores__WEBPACK_IMPORTED_MODULE_2__/* .useTypedSelector */ .ix)(function(state) {
        return state.app.hideAnnouncement;
    });
    var showAnnouncement = hasAnnouncement && !hideAnnouncement;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "z-30 h-[60px] sticky ".concat(showAnnouncement ? "top-[86px]" : "top-[56px]", " left-0 backdrop-blur bg-white/60 text-base layout-content px-5 md:px-[84px] flex items-center gap-11"),
        children: menus.map(function(menu, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: menu.route,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-sm font-semibold text-primary action",
                    children: menu.label
                })
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NetworkMenu);


/***/ }),

/***/ 88432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_common_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58163);


var NotAvailableTip = function(param) {
    var title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-center justify-center max-w-[418px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_icons__WEBPACK_IMPORTED_MODULE_1__/* .CommerceIcon */ ._y, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-xl font-semibold mt-8",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-4 text-gray1 text-center",
                children: desc
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotAvailableTip);


/***/ }),

/***/ 24129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ airdrop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-div-100vh/dist/esm/index.js
var esm = __webpack_require__(66409);
// EXTERNAL MODULE: ./src/components/common/Nav.tsx + 4 modules
var Nav = __webpack_require__(27356);
// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./src/hooks/useRequest.tsx
var useRequest = __webpack_require__(21706);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/network/NetworkMenu.tsx
var NetworkMenu = __webpack_require__(21862);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/common/icons.tsx
var icons = __webpack_require__(58163);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(91759);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(31003);
;// CONCATENATED MODULE: ./src/components/network/airdrop/AirdropDetail.tsx





var AirdropDetail = function(param) {
    var airdrop = param.airdrop, withClaimBtn = param.withClaimBtn, onClaim = param.onClaim, claiming = param.claiming, claimable = param.claimable, _size = param.size, size = _size === void 0 ? "md" : _size;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], toggle = ref[1].toggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between font-semibold ".concat(size === "sm" ? "text-base" : "text-xl", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            airdrop.name,
                            airdrop.locked && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center ml-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LockIcon */.mB, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-normal text-base text-gray1 ml-1",
                                        children: "Locked"
                                    })
                                ]
                            }),
                            airdrop.rule && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-primary action hover:text-primary ml-2 font-medium text-base",
                                href: airdrop.rule,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "view rules"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            withClaimBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "outline",
                                size: "xs",
                                radius: "xl",
                                className: "w-[64px] h-[24px] mr-4",
                                onClick: onClaim,
                                loading: claiming,
                                disabled: !claimable,
                                children: "Claim"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hover:cursor-pointer flex items-center",
                                onClick: toggle,
                                children: [
                                    airdrop.claimTokens || "--",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-normal ml-2 text-base",
                                        children: "KAT"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDownIcon */.ve, {
                                        className: "transition-all self-center w-2 ml-2 ".concat(airdrop.locked ? "fill-[#E0E1E1]" : "", " ").concat(opened ? "rotate-180" : "")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            airdrop.tip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 text-sm",
                children: airdrop.tip
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                in: opened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-6 mt-4 flex flex-col gap-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                        className: "w-full",
                        style: {
                            borderCollapse: "separate",
                            borderSpacing: "0 20px"
                        },
                        children: airdrop.parts.map(function(part, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        width: "75%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm font-semibold mb-1",
                                                children: part.label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xs whitespace-pre-line min-h-[20px]",
                                                dangerouslySetInnerHTML: {
                                                    __html: part.desc
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm font-semibold mb-1",
                                                children: "Score"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: part.score === "--" ? "--" : part.score
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        className: "text-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm font-semibold mb-1",
                                                children: "$KAT"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: part.tokens === "--" ? "--" : part.tokens
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var airdrop_AirdropDetail = (AirdropDetail);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/services/network/index.ts
var network = __webpack_require__(4600);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 71 modules
var chunk_LAFZBYO7 = __webpack_require__(17276);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./src/services/contract.ts + 10 modules
var contract = __webpack_require__(26720);
// EXTERNAL MODULE: ./src/utils/validate.ts
var validate = __webpack_require__(68974);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/parseUnits.js
var parseUnits = __webpack_require__(22852);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js + 70 modules
var index_client = __webpack_require__(11772);
;// CONCATENATED MODULE: ./src/hooks/airdrop/useUserAirdrop.tsx














function useUserAirdrop() {
    var address = (0,useAccount/* default */.Z)().address;
    var ref = (0,react.useState)(false), basicClaimLoading = ref[0], setBasicClaimLoading = ref[1];
    var ref1 = (0,react.useState)(false), validatorClaimLoading = ref1[0], setValidatorClaimLoading = ref1[1];
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var ref2 = (0,react.useState)(false), basicClaimed = ref2[0], setBasicClaimed = ref2[1];
    var ref3 = (0,react.useState)(false), validatorClaimed = ref3[0], setValidatorClaimed = ref3[1];
    var ref4 = (0,dist/* useContractReads */.Dm)({
        watch: false,
        scopeKey: "validator-airdrop-contract",
        contracts: address ? [
            // {
            //   ...validatorAirdropContractInfo,
            //   functionName: "claimed",
            //   args: [address],
            // },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* tokenAirdropContractInfo */.Go), {
                functionName: "claimed",
                args: [
                    address
                ]
            }), 
        ] : []
    }), validatorContractData = ref4.data, error = ref4.error;
    console.log("validatorContractData", validatorContractData, contract/* tokenAirdropContractInfo */.Go, contract/* validatorAirdropContractInfo */.ay, error);
    (0,react.useEffect)(function() {
        if (validatorContractData) {
            var ref;
            setBasicClaimed(!!(validatorContractData === null || validatorContractData === void 0 ? void 0 : (ref = validatorContractData[0]) === null || ref === void 0 ? void 0 : ref.result));
        // setValidatorClaimed(!!validatorContractData?.[0]?.result);
        }
    }, [
        validatorContractData
    ]);
    var validatorClaim = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var claimInfo, trans, transReceipt, e, e1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        10,
                        11,
                        12
                    ]);
                    setValidatorClaimLoading(true);
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== contract/* validatorAirdropContractInfo.chainId */.ay.chainId)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* switchNetwork */.If)({
                            chainId: contract/* validatorAirdropContractInfo.chainId */.ay.chainId
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0,network/* getValidatorAirdropClaimInfo */.DE)({
                            address: address
                        })
                    ];
                case 3:
                    claimInfo = _state.sent();
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* writeContract */.n9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* validatorAirdropContractInfo */.ay), {
                            functionName: "claim",
                            args: [
                                claimInfo.tokenIds,
                                claimInfo.amounts,
                                claimInfo.merkleProofs
                            ]
                        }))
                    ];
                case 4:
                    trans = _state.sent();
                    console.log("trans", trans);
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        9
                    ]);
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                            hash: trans.hash
                        })
                    ];
                case 6:
                    transReceipt = _state.sent();
                    if (transReceipt.status === "reverted") {
                        throw new Error("Claim fail");
                    }
                    return [
                        3,
                        9
                    ];
                case 7:
                    e = _state.sent();
                    return [
                        4,
                        (0,validate/* isSkipError */.D0)(e)
                    ];
                case 8:
                    if (!_state.sent()) {
                        throw e;
                    }
                    return [
                        3,
                        9
                    ];
                case 9:
                    setValidatorClaimed(true);
                    react_toastify_esm/* toast.success */.Am.success("Claim success");
                    return [
                        3,
                        12
                    ];
                case 10:
                    e1 = _state.sent();
                    if ((0,validate/* isUserRejectError */.Qd)(e1)) {
                        return [
                            2
                        ];
                    }
                    console.error(e1);
                    react_toastify_esm/* toast.error */.Am.error(e1.message);
                    throw new Error(e1.message);
                case 11:
                    setValidatorClaimLoading(false);
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }), [
        address
    ]);
    var basicClaim = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var claimInfo, trans, transReceipt, e, e1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        10,
                        12,
                        13
                    ]);
                    setBasicClaimLoading(true);
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== contract/* tokenAirdropContractInfo.chainId */.Go.chainId)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* switchNetwork */.If)({
                            chainId: contract/* tokenAirdropContractInfo.chainId */.Go.chainId
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0,network/* getAirdropClaimInfo */.QO)({
                            address: address
                        })
                    ];
                case 3:
                    claimInfo = _state.sent();
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* writeContract */.n9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* tokenAirdropContractInfo */.Go), {
                            functionName: "claim",
                            args: [
                                address,
                                (0,parseUnits/* parseUnits */.v)(String(claimInfo.amount), 18),
                                claimInfo.proof
                            ]
                        }))
                    ];
                case 4:
                    trans = _state.sent();
                    console.log("trans", trans.hash);
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        9
                    ]);
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                            hash: trans.hash
                        })
                    ];
                case 6:
                    transReceipt = _state.sent();
                    if (transReceipt.status === "reverted") {
                        throw new Error("Claim fail");
                    }
                    return [
                        3,
                        9
                    ];
                case 7:
                    e = _state.sent();
                    return [
                        4,
                        (0,validate/* isSkipError */.D0)(e)
                    ];
                case 8:
                    if (!_state.sent()) {
                        throw e;
                    }
                    return [
                        3,
                        9
                    ];
                case 9:
                    setBasicClaimed(true);
                    react_toastify_esm/* toast.success */.Am.success("Claim success");
                    return [
                        3,
                        13
                    ];
                case 10:
                    e1 = _state.sent();
                    if ((0,validate/* isUserRejectError */.Qd)(e1)) {
                        return [
                            2
                        ];
                    }
                    console.log("claimInfo", JSON.stringify(claimInfo));
                    console.error(e1);
                    (0,index_client/* captureException */.Tb)(e1);
                    return [
                        4,
                        (0,validate/* isSkipError */.D0)(e1)
                    ];
                case 11:
                    if (_state.sent()) {
                        return [
                            2
                        ];
                    }
                    react_toastify_esm/* toast.error */.Am.error(e1.message);
                    return [
                        3,
                        13
                    ];
                case 12:
                    setBasicClaimLoading(false);
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    }), [
        address
    ]);
    return {
        basicClaim: basicClaim,
        basicClaimLoading: basicClaimLoading,
        basicClaimed: basicClaimed,
        validatorClaim: validatorClaim,
        validatorClaimLoading: validatorClaimLoading,
        validatorClaimed: false
    };
}

// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/components/network/NotAvaliableTip.tsx
var NotAvaliableTip = __webpack_require__(88432);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/stores/index.ts + 23 modules
var stores = __webpack_require__(27234);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/pages/network/airdrop/index.tsx



















function parseAmount(amount) {
    if (!amount) {
        return 0;
    }
    if (amount === "-" || amount === "--") {
        return 0;
    }
    if (typeof amount === "string") {
        return parseFloat(amount);
    }
    return amount;
}
function processAirdropInfo(airdropInfo) {
    var ref, ref1, ref2;
    var airdrop1 = {
        parts: [
            {
                label: "Claimer",
                desc: "The reward of your wallet quality",
                score: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Claimer_Score),
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Claimer_Tokens)
            },
            {
                label: "Validator",
                desc: "The reward of your validator node",
                score: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Validator_Score),
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Validator_Tokens)
            },
            {
                label: "Lieutenant",
                desc: "Your contribution to other validator nodes",
                score: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Lieutenant_Score),
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Lieutenant_Tokens)
            },
            {
                label: "Early Supporter",
                desc: "Reward to validator #30-107",
                score: "--",
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Early_Supporter_Tokens)
            }, 
        ],
        name: "Airdrop #1",
        claimTokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Total_Tokens),
        locked: false,
        rule: "https://medium.com/@karatdao/karatdao-airdrop-update-3c74343fdf01"
    };
    var airdrop2 = {
        parts: [
            {
                label: "Claimer",
                desc: "The reward of your wallet quality",
                score: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Claimer_Score),
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Claimer_Tokens_unlocked)
            },
            {
                label: "Lieutenant",
                desc: "Your contribution to other validator nodes",
                score: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Lieutenant_Score),
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Lieutenant_Tokens)
            },
            {
                label: "VC",
                desc: "First 100,000 VC Holder will be eligible for this",
                score: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_VC_Score),
                tokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_VC_Tokens)
            }, 
        ],
        name: "Airdrop #2",
        rule: "https://medium.com/@karatdao/2nd-round-karat-airdrop-rules-97f231de99b1",
        claimTokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Total_Tokens),
        locked: false
    };
    var validatorAirdrop = {
        parts: [],
        name: "Validator reward from airdrop #2",
        claimTokens: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : (ref = airdropInfo.A2ValidatorAirdrop) === null || ref === void 0 ? void 0 : ref.claimableAmount),
        locked: false,
        tip: "Reward unlocks when 35,000 KAT are staked into your validator"
    };
    airdropInfo === null || airdropInfo === void 0 ? void 0 : (ref1 = airdropInfo.A2ValidatorAirdrop) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.validators) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(validator) {
        validatorAirdrop.parts.push({
            label: "Validator #".concat(validator.tokenId),
            desc: " ",
            score: (0,format/* KATAmountFormat */.iR)(validator.score),
            tokens: (0,format/* KATAmountFormat */.iR)(validator.tokenAmount)
        });
    });
    return {
        airdrop1: airdrop1,
        airdrop2: airdrop2,
        validatorAirdrop: validatorAirdrop
    };
}
var airdropOpenDate = new Date("2023-08-24T09:00:00.000Z");
var AirdropPage = function() {
    var ref, ref1;
    var height = (0,esm/* use100vh */.g)();
    var ref2 = (0,useAccount/* default */.Z)(), login = ref2.login, address = ref2.address, isLogin = ref2.isLogin;
    var ref3 = (0,react.useState)(processAirdropInfo()), airdrops = ref3[0], setAirdrops = ref3[1];
    var ref4 = useUserAirdrop(), basicClaim = ref4.basicClaim, basicClaimLoading = ref4.basicClaimLoading, validatorClaim = ref4.validatorClaim, validatorClaimLoading = ref4.validatorClaimLoading, basicClaimed = ref4.basicClaimed, validatorClaimed = ref4.validatorClaimed;
    var canAccess = isLogin && address;
    var airdropRetweetDate = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.app.airdropRetweetDate;
    });
    var showRetweet = !airdropRetweetDate || Date.now() - new Date(airdropRetweetDate).getTime() > 60 * 1000 * 60 * 24;
    var ref5 = (0,useRequest/* default */.Z)(canAccess ? {
        function: "network/getAirdropInfo",
        data: {
            address: address
        },
        header: {
            endpoint: "network"
        }
    } : null, (0,_object_spread/* default */.Z)({}, useRequest/* disableRevalidate */.U)), airdropInfo = ref5.data, mutate = ref5.mutate, isLoading = ref5.isLoading;
    (0,react.useEffect)(function() {
        setAirdrops(processAirdropInfo(airdropInfo));
    }, [
        airdropInfo
    ]);
    var onClaim = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (basicClaimLoading || basicClaimed) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            basicClaim()
                        ];
                    case 1:
                        _state.sent();
                        mutate();
                        return [
                            2
                        ];
                }
            });
        });
        return function onClaim() {
            return _ref.apply(this, arguments);
        };
    }();
    var onRetweet = (0,react.useCallback)(function() {
        stores/* default.dispatch */.ZP.dispatch(stores/* actions.app.showAirdropRetweet */.Nw.app.showAirdropRetweet());
        window.open("https://twitter.com/intent/tweet?text=".concat(encodeURIComponent("Karat to the MOON!! I just received ".concat((airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.basicClaimableAmount) || 0, " $KAT from @KaratDAO Alpha Mining. Start joining the Karat Mainnet and get a head start to 10X more rewards. #KAT #KaratDAO #socialfisummer"))), "_blank");
    }, [
        airdropInfo
    ]);
    var hasAirdrop = !!(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.Owner) || isLoading;
    var hasValidatorAirdrop = !!(airdropInfo === null || airdropInfo === void 0 ? void 0 : (ref = airdropInfo.A2ValidatorAirdrop) === null || ref === void 0 ? void 0 : (ref1 = ref.validators) === null || ref1 === void 0 ? void 0 : ref1.length);
    var totalAmount = parseAmount(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A1_Total_Tokens) + parseAmount(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Total_Tokens) + parseAmount(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Validator_Tokens) + parseAmount(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Claimer_Tokens_locked);
    var claimable = new Date() >= airdropOpenDate;
    var btns = lodash_default().shuffle([
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            variant: "outline",
            radius: "xl",
            className: "w-[215px] h-[44px] mt-4 !bg-white",
            loading: basicClaimLoading,
            onClick: onClaim,
            children: "Claim"
        }, (Math.random() + 1).toString(36).substring(7)),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            variant: "outline",
            radius: "xl",
            className: "w-[215px] h-[44px] mt-4 !bg-white hidden",
            children: "Claim"
        }, (Math.random() + 1).toString(36).substring(7)), 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: height ? "".concat(height, "px") : "100vh"
        },
        id: "container",
        className: "w-screen overflow-x-hidden overflow-y-scroll font-exo text-base bg-[url('/assets/network/airdrop/airdrop-bg.png')] bg-cover bg-no-repeat",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                showConnect: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NetworkMenu/* default */.Z, {}),
            canAccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[calc(100%-56px)] overflow-y-scroll px-5 pt-[10vh]",
                children: [
                    hasAirdrop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full sm:w-[785px] mx-auto px-5 sm:px-[52px] py-5 sm:py-[60px] mb-20 flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[48px] font-extrabold leading-[1.1]",
                                children: "KAT Airdrop"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full ".concat(isLoading ? "blur-md" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-12 w-full rounded-lg shadow-card bg-white p-6 flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "bg-[#EBF3FF] pt-10 px-6 pb-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center justify-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[36px] font-extrabold text-brand2",
                                                                children: (0,format/* KATAmountFormat */.iR)(basicClaimed ? 0 : (airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.basicClaimableAmount) || 0)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "ml-2 font-semibold text-xl",
                                                                children: "KAT"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-center",
                                                        children: !claimable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                            variant: "outline",
                                                            radius: "xl",
                                                            className: "w-[215px] h-[44px] mt-4",
                                                            disabled: true,
                                                            children: basicClaimed ? "Claimed" : "Claim"
                                                        }) : basicClaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                            variant: "outline",
                                                            radius: "xl",
                                                            className: "w-[215px] h-[44px] mt-4",
                                                            disabled: true,
                                                            children: "Claimed"
                                                        }) : showRetweet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                            variant: "outline",
                                                            radius: "xl",
                                                            className: "w-[215px] h-[44px] mt-4 !bg-white",
                                                            onClick: onRetweet,
                                                            children: "Tweet and claim"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: btns
                                                        })
                                                    }),
                                                    !claimable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-4 text-center font-xs text-dark1",
                                                        children: [
                                                            "Claimable on",
                                                            " ",
                                                            dayjs_min_default()(airdropOpenDate).format("M/D/YYYY @ hh A")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col gap-6 mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(airdrop_AirdropDetail, {
                                                        airdrop: airdrops.airdrop1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(airdrop_AirdropDetail, {
                                                        airdrop: airdrops.airdrop2
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    hasValidatorAirdrop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 w-full rounded-lg shadow-card bg-white p-6 flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(airdrop_AirdropDetail, {
                                            airdrop: airdrops.validatorAirdrop,
                                            withClaimBtn: true,
                                            size: "sm",
                                            claiming: validatorClaimLoading,
                                            claimable: false,
                                            onClaim: function() {
                                                if (validatorClaimLoading || validatorClaimed) {
                                                    return;
                                                }
                                                validatorClaim();
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-6 w-full rounded-lg shadow-card bg-white p-6 flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold",
                                                        children: "Claimer reward from airdrop #2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                variant: "default",
                                                                size: "xs",
                                                                radius: "xl",
                                                                className: "w-[64px] h-[24px]",
                                                                disabled: true,
                                                                children: "Claim"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-center ml-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "font-semibold",
                                                                        children: (0,format/* KATAmountFormat */.iR)(airdropInfo === null || airdropInfo === void 0 ? void 0 : airdropInfo.A2_Claimer_Tokens_locked)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "ml-2",
                                                                        children: "KAT"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm text-gray1 mt-3 max-w-[360px]",
                                                children: "You will be able to unlock this portion after completing\nour campaigns in the coming months. Stay tuned!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 w-full rounded-lg shadow-card bg-white p-6 flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between font-semibold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Total amount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        (0,format/* KATAmountFormat */.iR)(totalAmount),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-normal ml-1",
                                                            children: "KAT"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !hasAirdrop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center mt-24",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotAvaliableTip/* default */.Z, {
                            title: "You don’t have any airdrops",
                            desc: "You don’t have any airdrops. But don’t worry, keep an eye out for future airdrops."
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-10 sm:px-[18vw] pt-[15vh] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col leading-tight sm:w-[384px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-5xl sm:text-[60px] font-extrabold",
                            children: "KAT Airdrop"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                "Connect your wallet to see if you qualify to receive KAT airdrop.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "action text-primary hover:text-primary",
                                    href: "https://medium.com/@karatdao/karatdao-airdrop-update-3c74343fdf01",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "View airdrop rules 1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "action text-primary hover:text-primary ml-2",
                                    href: "https://medium.com/@karatdao/2nd-round-karat-airdrop-rules-97f231de99b1",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Airdrop rules 2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: "w-[229px] h-[44px] mt-12",
                            radius: "xl",
                            onClick: login,
                            children: address ? "Sign message" : " Connect wallet"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var airdrop = (AirdropPage);


/***/ }),

/***/ 4600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ getValidatorAirdropClaimInfo; },
/* harmony export */   "LC": function() { return /* binding */ getVestingClaimInfo; },
/* harmony export */   "QO": function() { return /* binding */ getAirdropClaimInfo; },
/* harmony export */   "t9": function() { return /* binding */ getRefereesTable; },
/* harmony export */   "yj": function() { return /* binding */ getNetworkInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6293);



var getRefereesTable = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!data.character || typeof data.validatorTokenId === "undefined") {
                        return [
                            2,
                            {
                                list: [],
                                pageSize: 0,
                                pageNum: 0,
                                size: 0,
                                next: 0,
                                total: 0,
                                pages: 0
                            }
                        ];
                    }
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getRefereesTable", data, {
                            endpoint: "network"
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getRefereesTable(data) {
        return _ref.apply(this, arguments);
    };
}();
var getNetworkInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getNetworkInfo", {})
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getNetworkInfo() {
        return _ref.apply(this, arguments);
    };
}();
var getVestingClaimInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getVestingClaimInfo", data)
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getVestingClaimInfo(data) {
        return _ref.apply(this, arguments);
    };
}();
var getAirdropClaimInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getAirdropClaimInfo", data)
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAirdropClaimInfo(data) {
        return _ref.apply(this, arguments);
    };
}();
var getValidatorAirdropClaimInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].rpc */ .Z.rpc("network/getValidatorAirdropClaimInfo", data)
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getValidatorAirdropClaimInfo(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3454,2280,6034,7258,4304,7172,2256,7356,9774,2888,179], function() { return __webpack_exec__(7872); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);